"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hsb2rgb = hsb2rgb;

/**
 * Converts HSB to RGB.
 * @param h Hue.
 * @param s Saturation.
 * @param b Brightness.
 */
function hsb2rgb(h, s, b) {
  s /= 100;
  b /= 100;
  var i = ~~(h / 60);
  var f = h / 60 - i;
  var p = b * (1 - s);
  var q = b * (1 - s * f);
  var t = b * (1 - s * (1 - f));
  var R;
  var G;
  var B;

  switch (i) {
    case 0:
    case 6:
    default:
      R = b;
      G = t;
      B = p;
      break;

    case 1:
      R = q;
      G = b;
      B = p;
      break;

    case 2:
      R = p;
      G = b;
      B = t;
      break;

    case 3:
      R = p;
      G = q;
      B = b;
      break;

    case 4:
      R = t;
      G = p;
      B = b;
      break;

    case 5:
      R = b;
      G = p;
      B = q;
      break;
  }

  return {
    r: Math.round(R * 255),
    g: Math.round(G * 255),
    b: Math.round(B * 255)
  };
}